import { render, staticRenderFns } from "./ButtonIconTooltip.vue?vue&type=template&id=5b973a87"
import script from "./ButtonIconTooltip.vue?vue&type=script&lang=js"
export * from "./ButtonIconTooltip.vue?vue&type=script&lang=js"
import style0 from "./ButtonIconTooltip.vue?vue&type=style&index=0&id=5b973a87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports